import { useFieldArray } from 'react-final-form-arrays';

export const useInitialCameraViewIndex = (fieldId: string) => {
  const { fields } = useFieldArray(`${fieldId}.images`, { subscription: { length: true, value: true } });
  if (fieldId.includes('damaged')) {
    return 0;
  }

  if ((!fieldId.includes('interior') && !fieldId.includes('tires') && !fieldId.includes('under_hood')) || !fields.value) {
    return fields.length || 0;
  }

  let index = -1;
  const typed = fields.value.filter(v => !!v.type)
  for (const i in typed) {
    if (!fields.value[i].url) {
      index = Number(i);
      break;
    }
  }

  if (index === -1) {
    return fields.length || 0;
  }

  return index;
};
